<template>
	<nav class="navbar bg-light navbar-expand-lg navbar-light p-md-0 pr-md-3">
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse text-center text-lg-left pb-4 pb-lg-0" id="main-nav">
			<a class="navbar-brand py-0 mr-0 mr-md-3" href="#">
			<Logo />
			</a>
			<div class="navbar-nav mr-auto mt-2 mt-lg-0">
				<router-link tag="li" to="#home" class="nav-item" active-class="active" exact>
					<a class="nav-link">Introduction</a>
				</router-link>
				<router-link tag="li" to="#benefits" class="nav-item" active-class="active" exact>
					<a class="nav-link">Benefits</a>
				</router-link>
				<router-link tag="li" to="#example-results" class="nav-item" active-class="active" exact>
					<a class="nav-link">Example Results</a>
				</router-link>
				<router-link tag="li" to="#how-it-works" class="nav-item" active-class="active" exact>
					<a class="nav-link">How it works</a>
				</router-link>
				<router-link tag="li" to="#pricing" class="nav-item" active-class="active" exact>
					<a class="nav-link">Pricing</a>
				</router-link>
			</div>
			<div class="navbar-nav align-items-center justify-content-between mt-2 mt-lg-0" v-if="authenticated === false">
				<li class="nav-item">
					<a href="#" class="nav-link text-primary" data-toggle="modal" data-target="#login-modal">
						Got an account? <b>Log in</b>
					</a>
				</li>
				<li class="nav-item ml-3">
					<ArrowLink text="Sign up now" to="#sign-up" />
				</li>
			</div>
			<div class="navbar-nav align-items-center justify-content-between mt-2 mt-lg-0" v-else>
				<!-- <router-link tag="li" :to="{ name: 'select-location' }" class="nav-item" active-class="active" exact>
					<a class="nav-link">Create Report</a>
				</router-link>
				<li class="nav-item ml-3 pr-0 pr-md-3 mb-3 mb-md-0">
					<router-link tag="a" :to="{ name: 'user-account' }" class="btn btn-outline-primary">Your Account</router-link>
				</li> -->
				<li class="nav-item ml-3 pr-0 pr-md-3 mb-3 mb-md-0">
					<div class="dropdown">
						<button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							Your Account
						</button>
						<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
							<router-link class="dropdown-item" :to="{ name: 'report-create' }">Create Report</router-link>
							<router-link class="dropdown-item" :to="{ name: 'report-history' }">Report History</router-link>
							<router-link class="dropdown-item" :to="{ name: 'user-account' }">Edit Account</router-link>
							<router-link v-if="role === 'Admin'" class="dropdown-item" :to="{ name: 'back-office' }">Back Office</router-link>
							<a class="dropdown-item" href="#" @click="logout">Logout</a>
						</div>
					</div>
				</li>
			</div>
		</div>
	</nav>
</template>
<script>
import ArrowLink from "@/components/ArrowLink.vue";
import Logo from "@/components/icons/Logo.vue";

export default {
	name: "Nav",
	components: {
		Logo,
		ArrowLink
	},
	data() {
    return {
      role: "User"
    };
	},
	mounted() {
		var role = localStorage.getItem('CWT_ROLE');
    if (role) {
      this.role = role;
    }
  },
	computed: {
    authenticated () {
      return this.$auth.isAuthenticated();
    }
	},
	methods:{
		logout(){
			this.$store.dispatch("logout");
		}
	}
};
</script>
